export default "__VITE_ASSET__d8eb3db3__"